export default "__VITE_ASSET__C7V0_NX6__"